<div class="content">
	<div class="showmore mt-40">
		<div class="info">Prikazanih {{( gallery | pagination:currentPage:20 ).length}} od {{gallery?.length}}</div>
		<div class="c"></div>
		<progress class="mt-20 mb-20" max="{{gallery?.length}}" value="{{( gallery | pagination:currentPage:20 ).length}}"></progress>
		<div class="c"></div>
		<div class="button clickable" (click)="nextPage" *ngIf="( gallery | pagination:currentPage:20 ).length < gallery.length">PRIKAŽI VEČ</div>
	</div>
</div>
